module.exports = __webpack_public_path__ + "files/01190096cc1e91b0056a22dc04a3477f.png";